exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] ._2AatwWz68SIFlRK-YqMCp9{padding:20px 0 10px 20px}html[dir=rtl] ._2AatwWz68SIFlRK-YqMCp9{padding:20px 20px 10px 0}", ""]);

// exports
exports.locals = {
	"txp": "_2AatwWz68SIFlRK-YqMCp9"
};